import { mapGetters } from "vuex";
// import * as types from "@/store/types";
const NumberInput = () => import("@/components/NumberInput/index");
import $thousandMask from "@/mixins/thousandMask";
import truncate from "@/filters/truncate";

const Captcha = () =>
  import(/* webpackChunkName: "Captcha" */ "@/components/Captcha/index");
export default {
  name: "buy",
  components: { NumberInput, Captcha },
  filters: { truncate },
  props: {
    selected: {
      type: String
    },
    inputModel: {},
    label: {
      type: String
    },
    error: {
      type: String
    },
    modalTitle: {
      type: String
    },
    modalInputPlaceholder: {
      type: String
    },
    list: {
      type: Array
    },
    almostText: {
      type: Boolean
    },
    getWallets: {
      type: Object
    }
  },
  mixins: [$thousandMask],
  data() {
    return {
      focusOnInput: false,
      showModal: false,
      fromValue: "",
      currencyList: [],
      search: "",
      imageBaseUrl: process.env.VUE_APP_IMAGE_BASE_URL
    };
  },
  // watch: {
  //   list() {
  //     this.addCurrencyFromWallet();
  //   },
  // },
  computed: {
    ...mapGetters({
      // getCurrencies: types.currencies.getters.GET_CURRENCIES,
      // getWallets: types.operations.getters.GET_WALLET,
      // exchanges: types.wallets.getters.GET_EXCHANGE_WALLETS
    }),

    filterResult() {
      if (this.list) {
        return this.list.filter(elem => {
          return (
            elem.name_locale
              .replace(/[^\p{L}]/gu, "")
              .includes(this.search.toLowerCase().replace(/[^\p{L}]/gu, "")) ||
            elem.name
              .replace(/[^\p{L}]/gu, "")
              .toLowerCase()
              .includes(this.search.toLowerCase().replace(/[^\p{L}]/gu, "")) ||
            elem.iso
              .replace(/[^\p{L}]/gu, "")
              .toLowerCase()
              .includes(this.search.toLowerCase().replace(/[^\p{L}]/gu, ""))
          );
        });
      }
    }
  },
  methods: {
    // addCurrencyFromWallet() {
    //   let walletPrice;
    //   this.currencyList = this.list.map((data) => {
    //     this.getWallets.wallets.find((elem) => {
    //       if (elem.iso === data.iso) {
    //         walletPrice = elem.balance_string_format;
    //       }
    //     });
    //     return {
    //       ...data,
    //       walletPrice: walletPrice,
    //     };
    //   });
    //   this.currencyList = this.currencyList.sort(
    //     ({ walletPrice: a }, { walletPrice: b }) => b - a
    //   );
    // },
    clickOnModalCurrency(value) {
      this.search = "";
      this.showModal = false;
      this.$emit("change", value.iso);
      this.$emit("input", "");
    },
    changeCurrencyInput({ target: { value } }) {
      this.$emit("input", value);
    },
    closeModal() {
      this.$refs.searchModal.scrollTop = 0;
      this.showModal = false;
      this.search = "";
    }
  }
};
